import { render } from "./CourseraPage.vue?vue&type=template&id=24d0b992&scoped=true"
import script from "./CourseraPage.vue?vue&type=script&lang=js"
export * from "./CourseraPage.vue?vue&type=script&lang=js"

import "./CourseraPage.vue?vue&type=style&index=0&id=24d0b992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d0b992"]])

export default __exports__